import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { LoadingPage } from "@hl/base-components/lib/LoadingPage";
import { Card, Container, Space, Stack, Text, Title } from "@mantine/core";
import { useAuth } from "./AuthContext";
import { SignInButton } from "./SignInButton";
export const ProtectedRoute = ({ children, message, showSignInOption = true, }) => {
    const { authenticated, loading } = useAuth();
    const authMessage = message || "This Page Requires Authentication";
    if (loading)
        return _jsx(LoadingPage, {});
    if (!authenticated) {
        return (_jsx(Container, { size: "xl", pt: 24, children: _jsx(Card, { withBorder: true, p: 40, children: _jsxs(Stack, { spacing: 0, align: "center", children: [_jsx(Title, { order: 5, children: "Not Signed In" }), _jsx(Space, { h: 16 }), _jsx(Text, { size: "sm", children: authMessage }), _jsx(Space, { h: 32 }), showSignInOption && _jsx(SignInButton, {})] }) }) }));
    }
    return _jsx(_Fragment, { children: children });
};
